import ApiResponse from "@core/types/apiResponse";
import { FinanceConfigSaveResponse } from "@features/admin/finance/types/deductibleConfig";
import {
    FinanceAllocationRuleResponse,
    FinanceAllocationRuleKpi,
} from "@features/admin/finance/allocation-rule/types/financeAllocationRule";
import {
    CreateFinanceAllocationRuleRequest,
    UpdateFinanceAllocationRuleRequest,
} from "@features/admin/finance/allocation-rule/types/financeAllocationRuleRequests";
import {
    fetchAllocationRuleKpis,
    fetchFinanceAllocationRules,
    createFinanceAllocationRule,
    updateFinanceAllocationRule,
    disableFinanceAllocationRule,
    enableFinanceAllocationRule,
} from "@features/admin/finance/allocation-rule/api/financeAllocationRuleApi";

export const fetchAllocationRuleKpisAsync = async (
    nationId: number
): Promise<ApiResponse<FinanceAllocationRuleKpi[]>> => {
    return fetchAllocationRuleKpis(nationId);
};

export const fetchFinanceAllocationRulesAsync = async (
    nationId: number,
    params: any
): Promise<ApiResponse<FinanceAllocationRuleResponse>> => {
    const { nationId: _removed, ...filteredParams } = params || {};
    return fetchFinanceAllocationRules(nationId, filteredParams);
};

export const createFinanceAllocationRuleAsync = async (
    nationId: number,
    data: CreateFinanceAllocationRuleRequest
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return createFinanceAllocationRule(nationId, data);
};

export const updateFinanceAllocationRuleAsync = async (
    nationId: number,
    ruleGroupId: number,
    data: UpdateFinanceAllocationRuleRequest
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return updateFinanceAllocationRule(nationId, ruleGroupId, data);
};

export const disableFinanceAllocationRuleAsync = async (
    nationId: number,
    ruleGroupId: number
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return disableFinanceAllocationRule(nationId, ruleGroupId);
};

export const enableFinanceAllocationRuleAsync = async (
    nationId: number,
    ruleGroupId: number
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return enableFinanceAllocationRule(nationId, ruleGroupId);
};
